import React from 'react';
import { themed } from '../../ui/theme';

interface Props {
  children: React.ReactNode;
  className?: string;
  /** Usar quando o card tem cabeçalho/itens com bordas que precisam ser recortados. */
  clip?: boolean;
}

// Container padrão de painel/seção.
//   minimal: cantos discretos, sem sombra.
//   saas:    cantos grandes + sombra suave.
const Card: React.FC<Props> = ({ children, className = '', clip = false }) => (
  <section className={`border border-slate-200 bg-white dark:border-slate-700 dark:bg-slate-800/60 ${clip ? 'overflow-hidden' : ''} ${themed({
    minimal: 'rounded-lg',
    saas: 'rounded-2xl shadow-sm',
  })} ${className}`}>
    {children}
  </section>
);

export default Card;
